import {Type} from "class-transformer";
import {AbstractItem} from './item';
import {serializeType} from "./common";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {FundingType} from "@app/shared/enums/funding-type.enum";

export class CustomerInvoiceItem {
  id: number;
  version: number;
  sequenceNum?: number;
  rowNum?: number;
  nameOrNumber?: string;
  subtype?: ItemType;
  description?: string;

  unitOfMeasureId?: number;
  internalNotes?: string;
  showOnInvoice: boolean;
  revenueType?: string;
  fundingType?: FundingType;
  cumulativeType?: string;
  salesPrice?: number;
  extendedPrice: number;
  ganda?: number;
  mandh?: number;
  taxAmount?: number;
  isTaxable: boolean;
  billedHoursYTD?: number;
  billedHoursITD?: number;
  billedHoursOldITD?: number;
  totalBilledITD?: number;
  totalBilledOldITD?: number;
  qtyDelivered?: number;
  qtyReturned?: number;
  qtyBackOrdered?: number;
  qtyAlreadyDelivered?: number;
  qtyAlreadyInvoiced?: number;
  laborCategoryId?: number;
  invoiceId: number;
  orderItemId?: number;
  abstractItemId?: number;
  packingSlipItemId?: number;
  billingScheduleId?: number;
  clinId?: number;
  taskId?: number;
  projectId?: number;
  clinNumber?: string;
  projectName?: string;
  taskName?: string;
  bold?: boolean;
  numberOfIndentation?: number;
  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;
  qtyOrdered?: number;
  unitOfMeasureDescription?: string;
  salesReturnId?: number;
  packingSlipId?: number;
  packingSlipNumber?: string;
  // Transient fields
  periodLaborIds?: number[];
  periodLaborCostIds?: number[];
  periodExpenseIds?: number[];
  periodExpenseCostIds?: number[];
}

export enum CumulativeType {
  LABOR_TOTAL = 'LABOR_TOTAL',
  DIRECT_LABOR = 'DIRECT_LABOR',
  FRINGE = 'FRINGE',
  OVERHEAD = 'OVERHEAD',
  GANDA_LABOR = 'GANDA_LABOR',
  LABOR_FIXED_FEE = 'LABOR_FIXED_FEE',
  FIRM_FIXED_PRICE_LABOR = 'FIRM_FIXED_PRICE_LABOR',
  EXPENSE_TOTAL = 'EXPENSE_TOTAL',
  TRAVEL = 'TRAVEL',
  MATERIAL = 'MATERIAL',
  TRAINING = 'TRAINING',
  ODC = 'ODC',
  GANDA_EXPENSE = 'GANDA_EXPENSE',
  MANDH_EXPENSE = 'MANDH_EXPENSE'
}